import { MAX_VALUE, MIN_VALUE } from './constants';

export function getNormalizedValue(gte: number | undefined): number | null {
  if (gte === undefined) {
    return null;
  }

  return Math.max(MIN_VALUE, Math.min(MAX_VALUE, gte));
}
